import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import demoVideo from '../../../assets/video/demo.mp4';

const DemoVideo = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <>
      <div className="mt-[16px] md:mt-[30px] w-full flex justify-center">
        <div
          className="relative w-full max-w-[1216px] rounded-[42px] overflow-hidden
          border-2 border-blue-100 bg-gradient-to-b
          from-[rgba(130,232,255,0.20)] via-[rgba(248,252,255,0.20)] to-[rgba(130,232,255,0.20)]
          p-[16px] md:p-[26px] box-border"
        >
          <div
            className="relative w-full aspect-video min-h-[200px] rounded-[32px] overflow-hidden group cursor-pointer"
            onClick={() => setOpen(true)}
          >
            <video
              className="absolute inset-0 w-full h-full object-cover"
              src={demoVideo}
              autoPlay
              muted
              loop
              playsInline
            />
            {/* Hover overlay */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
              <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center gap-[8px] px-[20px] py-[10px] rounded-[32px] bg-surface-base/90 text-blue-link font-medium text-[14px] shadow-lg">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M4 3.5l9 4.5-9 4.5V3.5z" />
                </svg>
                {t('home.watchFullScreen')}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4">
          {/* Backdrop click to close */}
          <div className="absolute inset-0" onClick={() => setOpen(false)} />

          {/* Close button */}
          <button
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-surface-base/15 hover:bg-surface-base/25 text-surface-base transition-colors cursor-pointer"
            aria-label="Close"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M2 2l12 12M14 2L2 14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>

          <video
            className="relative z-10 max-w-full max-h-[90vh] w-auto rounded-[12px] shadow-2xl"
            src={demoVideo}
            controls
            autoPlay
            playsInline
          />
        </div>
      )}
    </>
  );
};

export default DemoVideo;
